import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { LazyTarget, LazyViewport } from './lazy-viewport';

@Directive({
    selector: "[lazySrc]",
    inputs: [
        "src: lazySrc",
        "visibleClass: lazySrcVisible",
        "fallbackImg: fallback"
    ]
})

export class LazySrcDirective implements OnInit, OnDestroy, LazyTarget {

    public element: Element;
    public src: string;
    public oblongSrc:string;
    public visibleClass: string = "visible";
    public fallbackImg: string = `assets/img/placeholder.png`;

    constructor(
        elementRef: ElementRef,
        private lazyViewport: LazyViewport,
        private readonly renderer: Renderer2
    ) {
        this.element = elementRef.nativeElement;
    }

    public ngOnDestroy(): void {
        if (this.lazyViewport) {
            this.lazyViewport.removeTarget(this);
            this.lazyViewport.teardown();
        }
    }

    public ngOnInit(): void {
        this.lazyViewport.addTarget(this);
    }

    public updateVisibility(isVisible: boolean, ratio: number): void {
        if (!isVisible)
            return;
        this.lazyViewport.removeTarget(this);
        this.lazyViewport = null;
        this.renderer.setProperty(this.element, "src", this.src);

        if (this.visibleClass){
          this.renderer.addClass(this.element, this.visibleClass);
          if(this.visibleClass ==='visible'){
            this.renderer.listen(this.element, 'error', () => this.renderer.setProperty(this.element, "src", this.fallbackImg));

        }
         else
           if(this.visibleClass ==='ClpVisible'){
            this.renderer.listen(this.element, 'error', () => this.renderer.setProperty(this.element, "src", `assets/img/small-place-holder.jpg`));

         }
        }

    }
}
